module.exports = __webpack_public_path__ + "04e6497f3923b87d64694814b58c7e88.png";